window.MANUARTI_DATA = window.MANUARTI_DATA || {};
window.MANUARTI_DATA.pages = [
  {
    title: 'Livorno',
    url: '/pages/livorno',
    handle: 'livorno',
    tags: ['tipo:provincia', 'provincia:livorno'],
  },
  {
    title: 'Firenze',
    url: '/pages/firenze',
    handle: 'firenze',
    tags: ['tipo:provincia', 'provincia:firenze'],
  },
  {
    title: 'Prato',
    url: '/pages/prato',
    handle: 'prato',
    tags: ['tipo:provincia', 'provincia:prato'],
  },
  {
    title: 'Pistoia',
    url: '/pages/pistoia',
    handle: 'pistoia',
    tags: ['tipo:provincia', 'provincia:pistoia'],
  },
  {
    title: 'Lucca',
    url: '/pages/lucca',
    handle: 'lucca',
    tags: ['tipo:provincia', 'provincia:lucca'],
  },
  {
    title: 'Massa-Carrara',
    url: '/pages/massa-carrara',
    handle: 'massa-carrara',
    tags: ['tipo:provincia', 'provincia:massa-carrara'],
  },
  {
    title: 'Grosseto',
    url: '/pages/grosseto',
    handle: 'grosseto',
    tags: ['tipo:provincia', 'provincia:grosseto'],
  },
  {
    title: 'Siena',
    url: '/pages/siena',
    handle: 'siena',
    tags: ['tipo:provincia', 'provincia:siena'],
  },
  {
    title: 'Arezzo',
    url: '/pages/arezzo',
    handle: 'arezzo',
    tags: ['tipo:provincia', 'provincia:arezzo'],
  },
  {
    title: 'Pisa',
    url: '/pages/pisa',
    handle: 'pisa',
    tags: ['tipo:provincia', 'provincia:pisa'],
  },
  {
    title: 'Al Bottegone',
    url: '/pages/franco-e-pupa',
    handle: 'franco-e-pupa',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-bottegone-riccardo.webp?width=600',
    tags: ['tipo:produttore', 'provincia:livorno', 'mestiere:bottega-alimentare', 'tmh:si'],
  },
  {
    title: 'Alimentari Procissi',
    url: '/pages/alimentari-procissi',
    handle: 'alimentari-procissi',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-procissi-insegna.png?width=600',
    tags: ['tipo:produttore', 'provincia:lucca', 'mestiere:bottega-alimentare', 'tmh:no'],
  },
  {
    title: 'Anna Gioielli',
    url: '/pages/anna-gioielli',
    handle: 'anna-gioielli',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-anna-winter-flower.webp?width=600',
    tags: ['tipo:produttore', 'provincia:firenze', 'mestiere:oreficeria', 'tmh:si'],
  },
  {
    title: 'Aries',
    url: '/pages/birrificio-aries',
    handle: 'birrificio-aries',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-aries-daniele.webp?width=600',
    tags: ['tipo:produttore', 'provincia:firenze', 'mestiere:birra-artigianale', 'tmh:si'],
  },
  {
    title: 'Bookendipity',
    url: '/pages/rondini',
    handle: 'rondini',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-rondini-gabriele-stand.webp?width=600',
    tags: ['tipo:produttore', 'provincia:pisa', 'mestiere:editoria-indipendente', 'tmh:si'],
  },
  {
    title: 'Clandestino',
    url: '/pages/birrificio-clandestino',
    handle: 'birrificio-clandestino',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-clandestino-galactica.webp?width=600',
    tags: ['tipo:produttore', 'provincia:livorno', 'mestiere:birra-artigianale', 'tmh:si'],
  },
  {
    title: 'EVA MUN',
    url: '/pages/eva-mun',
    handle: 'eva-mun',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-evamun-atelier.webp?width=600',
    tags: ['tipo:produttore', 'provincia:firenze', 'mestiere:ceramica', 'tmh:si'],
  },
  {
    title: 'Florence Gioielli',
    url: '/pages/florence-gioielli',
    handle: 'florence-gioielli',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-florence-gioielli-insegna.png?width=600',
    tags: ['tipo:produttore', 'provincia:firenze', 'tmh:no'],
  },
  {
    title: 'GlowBlooms',
    url: '/pages/glowblooms',
    handle: 'glowblooms',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-glowblooms-demetra.webp?width=600',
    tags: ['tipo:produttore', 'provincia:livorno', 'mestiere:fiori-e-decorazioni', 'tmh:si'],
  },
  {
    title: 'Il Papavero Decorazioni',
    url: '/pages/il-papavero',
    handle: 'il-papavero',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-papavero-pioggia.webp?width=600',
    tags: ['tipo:produttore', 'provincia:firenze', 'mestiere:ceramica', 'tmh:si'],
  },
  {
    title: 'Kerstin Simply Creative',
    url: '/pages/kerstin',
    handle: 'kerstin',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-kerstin-portacandele.webp?width=600',
    tags: ['tipo:produttore', 'provincia:firenze', 'mestiere:ceramica', 'tmh:si'],
  },
  {
    title: 'L\'ARTE DI CREARE',
    url: '/pages/arte-di-creare',
    handle: 'arte-di-creare',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-arte-di-creare-banco.webp?width=600',
    tags: ['tipo:produttore', 'provincia:pistoia', 'mestiere:oreficeria', 'tmh:si'],
  },
  {
    title: 'L\'ARTES Since 1968',
    url: '/pages/lartes',
    handle: 'lartes',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-lartes-falegnameria.webp?width=600',
    tags: ['tipo:produttore', 'provincia:firenze', 'mestiere:falegnameria-artistica', 'tmh:si'],
  },
  {
    title: 'La Fattoria di Afelba',
    url: '/pages/la-fattoria-di-afelba',
    handle: 'la-fattoria-di-afelba',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-afelba-insegna.png?width=600',
    tags: ['tipo:produttore', 'provincia:livorno', 'mestiere:olio-evo', 'tmh:no'],
  },
  {
    title: 'La Foresta',
    url: '/pages/la-foresta',
    handle: 'la-foresta',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-foresta-raccolta.webp?width=600',
    tags: ['tipo:produttore', 'provincia:arezzo', 'mestiere:olio-evo', 'tmh:si'],
  },
  {
    title: 'Mokalux',
    url: '/pages/mokalux',
    handle: 'mokalux',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-mokalux-tostatrice.webp?width=600',
    tags: ['tipo:produttore', 'provincia:firenze', 'mestiere:torrefazione', 'tmh:si'],
  },
  {
    title: 'Pasta Bertoli',
    url: '/pages/pasta-bertoli',
    handle: 'pasta-bertoli',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-bertoli-mani-nel-grano.webp?width=600',
    tags: ['tipo:produttore', 'provincia:pisa', 'mestiere:pasta-e-prodotti-da-forno', 'tmh:si'],
  },
  {
    title: 'Podere Macolo',
    url: '/pages/podere-macolo',
    handle: 'podere-macolo',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-macolo-titolari.webp?width=600',
    tags: ['tipo:produttore', 'provincia:pistoia', 'mestiere:olio-evo', 'tmh:no'],
  },
  {
    title: 'Sapori della Rocca',
    url: '/pages/sapori-della-rocca',
    handle: 'sapori-della-rocca',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-sapori-nonna.webp?width=600',
    tags: ['tipo:produttore', 'provincia:firenze', 'mestiere:conserve-e-preparati', 'tmh:si'],
  },
  {
    title: 'Uccelliera',
    url: '/pages/uccelliera',
    handle: 'uccelliera',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-uccelliera-vigne.webp?width=600',
    tags: ['tipo:produttore', 'provincia:pisa', 'mestiere:vino', 'tmh:si'],
  },
  {
    title: 'Visionair Gin',
    url: '/pages/visionair-gin',
    handle: 'visionair-gin',
    image: 'https://cdn.shopify.com/s/files/1/1011/4960/6235/files/manuarti-visionair-tavolo-mare.webp?width=600',
    tags: ['tipo:produttore', 'provincia:firenze', 'mestiere:liquoreria-e-distillati', 'tmh:si'],
  },
  {
    title: 'Oreficeria',
    url: '/pages/oreficeria',
    handle: 'oreficeria',
    tags: ['tipo:mestiere', 'mestiere:oreficeria', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Pelletteria',
    url: '/pages/pelletteria',
    handle: 'pelletteria',
    tags: ['tipo:mestiere', 'mestiere:pelletteria', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Calzoleria artigianale',
    url: '/pages/calzoleria-artigianale',
    handle: 'calzoleria-artigianale',
    tags: ['tipo:mestiere', 'mestiere:calzoleria-artigianale', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Ceramica',
    url: '/pages/ceramica',
    handle: 'ceramica',
    tags: ['tipo:mestiere', 'mestiere:ceramica', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Terracotta',
    url: '/pages/terracotta',
    handle: 'terracotta',
    tags: ['tipo:mestiere', 'mestiere:terracotta', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Vetro artistico',
    url: '/pages/vetro-artistico',
    handle: 'vetro-artistico',
    tags: ['tipo:mestiere', 'mestiere:vetro-artistico', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Argenteria',
    url: '/pages/argenteria',
    handle: 'argenteria',
    tags: ['tipo:mestiere', 'mestiere:argenteria', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Fabbro e lavorazione metalli',
    url: '/pages/fabbro-e-lavorazione-metalli',
    handle: 'fabbro-e-lavorazione-metalli',
    tags: ['tipo:mestiere', 'mestiere:fabbro-e-lavorazione-metalli', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Lavorazione marmo e pietra',
    url: '/pages/lavorazione-marmo-e-pietra',
    handle: 'lavorazione-marmo-e-pietra',
    tags: ['tipo:mestiere', 'mestiere:lavorazione-marmo-e-pietra', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Mosaico',
    url: '/pages/mosaico',
    handle: 'mosaico',
    tags: ['tipo:mestiere', 'mestiere:mosaico', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Cartotecnica e legatoria',
    url: '/pages/cartotecnica-e-legatoria',
    handle: 'cartotecnica-e-legatoria',
    tags: ['tipo:mestiere', 'mestiere:cartotecnica-e-legatoria', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Editoria indipendente',
    url: '/pages/editoria-indipendente',
    handle: 'editoria-indipendente',
    tags: ['tipo:mestiere', 'mestiere:editoria-indipendente', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Falegnameria artistica',
    url: '/pages/falegnameria-artistica',
    handle: 'falegnameria-artistica',
    tags: ['tipo:mestiere', 'mestiere:falegnameria-artistica', 'categoria:legno'],
  },
  {
    title: 'Restauro e intaglio',
    url: '/pages/restauro-e-intaglio',
    handle: 'restauro-e-intaglio',
    tags: ['tipo:mestiere', 'mestiere:restauro-e-intaglio', 'categoria:legno'],
  },
  {
    title: 'Tessitura',
    url: '/pages/tessitura',
    handle: 'tessitura',
    tags: ['tipo:mestiere', 'mestiere:tessitura', 'categoria:tessile-e-abbigliamento'],
  },
  {
    title: 'Sartoria artigianale',
    url: '/pages/sartoria-artigianale',
    handle: 'sartoria-artigianale',
    tags: ['tipo:mestiere', 'mestiere:sartoria-artigianale', 'categoria:tessile-e-abbigliamento'],
  },
  {
    title: 'Ricamo',
    url: '/pages/ricamo',
    handle: 'ricamo',
    tags: ['tipo:mestiere', 'mestiere:ricamo', 'categoria:tessile-e-abbigliamento'],
  },
  {
    title: 'Cappelleria',
    url: '/pages/cappelleria',
    handle: 'cappelleria',
    tags: ['tipo:mestiere', 'mestiere:cappelleria', 'categoria:tessile-e-abbigliamento'],
  },
  {
    title: 'Olio EVO',
    url: '/pages/olio-evo',
    handle: 'olio-evo',
    tags: ['tipo:mestiere', 'mestiere:olio-evo', 'categoria:enogastronomia'],
  },
  {
    title: 'Vino',
    url: '/pages/vino',
    handle: 'vino',
    tags: ['tipo:mestiere', 'mestiere:vino', 'categoria:enogastronomia'],
  },
  {
    title: 'Bottega alimentare',
    url: '/pages/bottega-alimentare',
    handle: 'bottega-alimentare',
    tags: ['tipo:mestiere', 'mestiere:bottega-alimentare', 'categoria:enogastronomia'],
  },
  {
    title: 'Fiori e decorazioni',
    url: '/pages/fiori-e-decorazioni',
    handle: 'fiori-e-decorazioni',
    tags: ['tipo:mestiere', 'mestiere:fiori-e-decorazioni', 'categoria:manufatti-e-artigianato'],
  },
  {
    title: 'Miele e apicoltura',
    url: '/pages/miele-e-apicoltura',
    handle: 'miele-e-apicoltura',
    tags: ['tipo:mestiere', 'mestiere:miele-e-apicoltura', 'categoria:enogastronomia'],
  },
  {
    title: 'Salumeria',
    url: '/pages/salumeria',
    handle: 'salumeria',
    tags: ['tipo:mestiere', 'mestiere:salumeria', 'categoria:enogastronomia'],
  },
  {
    title: 'Formaggi',
    url: '/pages/formaggi',
    handle: 'formaggi',
    tags: ['tipo:mestiere', 'mestiere:formaggi', 'categoria:enogastronomia'],
  },
  {
    title: 'Conserve e preparati',
    url: '/pages/conserve-e-preparati',
    handle: 'conserve-e-preparati',
    tags: ['tipo:mestiere', 'mestiere:conserve-e-preparati', 'categoria:enogastronomia'],
  },
  {
    title: 'Pasta e prodotti da forno',
    url: '/pages/pasta-e-prodotti-da-forno',
    handle: 'pasta-e-prodotti-da-forno',
    tags: ['tipo:mestiere', 'mestiere:pasta-e-prodotti-da-forno', 'categoria:enogastronomia'],
  },
  {
    title: 'Cioccolato e dolciaria',
    url: '/pages/cioccolato-e-dolciaria',
    handle: 'cioccolato-e-dolciaria',
    tags: ['tipo:mestiere', 'mestiere:cioccolato-e-dolciaria', 'categoria:enogastronomia'],
  },
  {
    title: 'Liquoreria e distillati',
    url: '/pages/liquoreria-e-distillati',
    handle: 'liquoreria-e-distillati',
    tags: ['tipo:mestiere', 'mestiere:liquoreria-e-distillati', 'categoria:enogastronomia'],
  },
  {
    title: 'Birra artigianale',
    url: '/pages/birra-artigianale',
    handle: 'birra-artigianale',
    tags: ['tipo:mestiere', 'mestiere:birra-artigianale', 'categoria:enogastronomia'],
  },
  {
    title: 'Torrefazione',
    url: '/pages/torrefazione',
    handle: 'torrefazione',
    tags: ['tipo:mestiere', 'mestiere:torrefazione', 'categoria:enogastronomia'],
  },
];
